import React from "react";
import { useMutation } from "react-query";
import { useToastContext } from "hooks/useToastContext";
import useTaskStatusQuery from "./useTaskStatusQuery";

export default function useFloweyAutoRefetchMutation(
	mutationFn,
	queryFn,
	options = {}
) {
	const [taskId, setTaskId] = React.useState(null);
	const toast = useToastContext();

	const defaultTiming = options.defaultTiming || 250;
	const maxTiming = options.maxTiming || 5000;

	const { taskStatusQuery, lastRefetchRef, resetTiming } = useTaskStatusQuery(
		{
			taskId,
			queryFn,
			options,
			toast,
			defaultTiming,
			maxTiming,
			onTaskSuccess: data => {
				setTaskId(null);
				options.onSuccess?.(data);
			},
			onTaskError: error => {
				setTaskId(null);
				options.onError?.(error);
			}
		}
	);

	const mutation = useMutation(mutationFn, {
		...options,
		onSuccess: response => {
			const taskIdValue = response?.task_id || response?.taskId;
			if (taskIdValue) {
				if (lastRefetchRef.current) {
					clearTimeout(lastRefetchRef.current);
					lastRefetchRef.current = null;
				}
				resetTiming();
				setTaskId(taskIdValue);
			} else {
				options.onSuccess?.(response);
			}
		},
		onError: error => {
			options.onError?.(error);
		}
	});

	const isLoading = mutation.isLoading || taskStatusQuery.isFetching;

	return {
		...mutation,
		isLoading,
		taskStatus: taskStatusQuery.data
	};
}
